import { Routes } from '@angular/router';
import { NotFoundComponent } from './not-found/not-found.component';
import { PLAN_BUILDING_ROUTES } from './eop-config/eop-routes';


export const routes: Routes = [
    {
        path: '',
        component: NotFoundComponent,
        data: {
            showSidebar: false,
            title: 'Invalid Plan URL',
            message: 'Open this page with a full MS plan URL such as /plans/ms/building/123/summary.'
        }
    },

    // NOTE: more specific routes first, for example, drill-training-collaboration-reports
    // then the less specific ones, for example, functional-annexes/:pageRoute
    // those must be before the general :pageRoute route
    ...PLAN_BUILDING_ROUTES,

    { path: 'not-found', component: NotFoundComponent, data: { showSidebar: false } },
    { path: 'unauthorized', component: NotFoundComponent, data: { showSidebar: false } },
    { path: '**', component: NotFoundComponent, data: { showSidebar: false } }
];
